import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,

    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    styles: []

})
export class PageLoaderComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
